import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
import { useCallback } from "react";

type IPriorityData = {
  name: string;
  canRender?: boolean;
};

type IPriorityStore = {
  elements: IPriorityData[];
};

const { Provider, useStore } = createContextStore<IPriorityStore>(
  {
    elements: [],
  },
  { name: "PriorityStore" }
);

export const PriorityProvider = Provider;

export const usePriority = (name: string) => {
  const [{ elements: elements }, setStore] = useStore(["elements"]);

  // for now we are only rendering the first element that can render
  const shouldRender =
    elements.find((element) => element.canRender)?.name === name;

  const registerToRender = useCallback(
    (canRender: boolean) => {
      setStore((store) => {
        const banner = store.elements.find((banner) => banner.name === name);

        if (!banner) {
          return { elements: [...store.elements, { name, canRender }] };
        }
        banner.canRender = canRender;
        return { elements: [...store.elements] };
      });

      const unregister = () =>
        setStore((store) => {
          const elements = store.elements.filter(
            (element) => element.name === name
          );
          return { elements };
        });

      return unregister;
    },
    [name, setStore]
  );

  return { shouldRender, registerToRender };
};
